'use client'

import { useState } from 'react'

import type { BlogPostComment } from '@types'

import Button from '@components/buttons/button'

import Comment from './comment'

import styles from './comment-list.module.scss'

type CommentsListProps = {
  comments: BlogPostComment[]
  numberOfComments: number
}
export default function CommentsList({ numberOfComments, comments }: CommentsListProps): JSX.Element {
  const [displayedComments, setDisplayedComments] = useState<number>(2)

  return (
    <div>
      {comments?.slice(0, displayedComments).map((comment) => <Comment key={comment.id} data={comment} />)}
      {numberOfComments && displayedComments < numberOfComments && (
        <Button
          variant="simple-text"
          className={styles['more-button']}
          onClick={(): void => setDisplayedComments((e) => e + 5)}
        >
          View more comments
        </Button>
      )}
    </div>
  )
}
